import { Button, TextField } from '@mui/material'
import React, { useState } from 'react'
import { useAuth } from '../../../../context/AuthContext'
import { useAlert } from '../../../../context/AlertContext'
import { FlexContainer } from '../../../../styles/common/FlexBox'
import { useLocation } from 'react-router-dom'
import useLoginEstacio from '../../../../hooks/useLoginEstacio'
import { CircularProgress } from '@mui/material'
const ClubeDoAluno = ({incentiveId, handleClose, onSuccess}) => {

const [matricula, setMatricula] = useState('');
  const [senha, setSenha] = useState('');
  const [formError, setFormError] = useState('');
  const { auth } = useAuth();
  const { showAlert } = useAlert();
  const location = useLocation();

  const { loginEstacio, loading } = useLoginEstacio();

  const searchParams = new URLSearchParams(location.search);
  const source = searchParams.get('utm_source');
  const campaign = searchParams.get('utm_campaign');

  const handleLogin = async (e) => {
    e.preventDefault();
    setFormError('');

    const { token, error } = await loginEstacio(matricula.trim(), senha, source, campaign, incentiveId);

    if (!token) {
      const message = error || 'Erro no login, verifique suas credenciais!';
      setFormError(message);
      showAlert(message, 'error');
      return;
    }

    const authenticated = await auth(+incentiveId);

    if (!authenticated) {
      const message = 'Sua conta não tem acesso a este clube.';
      setFormError(message);
      showAlert(message, 'error');
      return;
    }

    showAlert('Login realizado com sucesso!', 'success');
    if (handleClose) handleClose();
    if (onSuccess) onSuccess();
  };
  return (
    <form onSubmit={handleLogin} noValidate={false}>
    <FlexContainer direction="column" justify="center" align="center" gap="1.5rem" margin="0 0 1rem 0" >

      <div>
        Para acessar o Clube, utilize sua senha do SIA (6 caracteres: 4 números e 2 letras).
      </div>

      <TextField
        id="matricula"
        name="matricula"
        label="Matrícula"
        variant="outlined"
        required
        fullWidth
        autoComplete="username"
        inputProps={{ inputMode: 'numeric' }}
        value={matricula}
        onChange={(e) => setMatricula(e.target.value)}
        error={!!formError}
      />

      <TextField
        id="senha"
        name="senha"
        label="Senha"
        type="password"
        variant="outlined"
        required
        fullWidth
        autoComplete="current-password"
        value={senha}
        onChange={(e) => setSenha(e.target.value)}
        error={!!formError}
        helperText={formError}
      />

      <Button
        className="btn-primary-2"
        variant="outlined"
        type="submit"
        disabled={loading}
        startIcon={loading ? <CircularProgress size={16} color="inherit" /> : null}
      >
        {loading ? 'Entrando...' : 'Entrar'}
      </Button>
    </FlexContainer>
    </form>
  )
}

export default ClubeDoAluno
